// Import model
import { StartContactAppointmentCancelAppointmentRequest } from '../models/StartContactAppointmentCancelAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentCancelAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentCancelAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentCancelAppointmentRequest instance
   */
  static deserialize(json: string): StartContactAppointmentCancelAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentCancelAppointmentRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentCancelAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentCancelAppointmentRequest');
    }


    const instance: StartContactAppointmentCancelAppointmentRequest = {
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentCancelAppointmentRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentCancelAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentCancelAppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentCancelAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentCancelAppointmentRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentCancelAppointmentRequest): any {
    return {
    };
  }

  /**
   * Serializes an array of StartContactAppointmentCancelAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentCancelAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
